import { h, Fragment } from "preact";

import AppLayout from "../components/AppLayout.jsx";
import ServerPaginated from "../components/ServerPaginated.jsx";
import TalentPoolItem from "../components/TalentPoolItem.jsx";
import SecondaryNavi from "../components/SecondaryNavi.jsx";
import Hint from "../components/HintContainer.jsx";

import i18n from "../i18n.js";
import talentsApi from "../api/talents";
import AppHeader from "../components/AppHeader.jsx";
import EmptyState from "../components/EmptyState.jsx";
import FilterBar from "../components/talentPool/FilterBar.jsx";
import { setTalents } from "../store";

const ID = "talentPool";

export default function TalentPoolPage({ previewMode }) {
  return (
    <AppLayout
      headerWithFilter
      header={
        <AppHeader
          title={i18n.t(
            `pages.titles.talentPool${previewMode ? "Preview" : ""}`
          )}
        >
          <SecondaryNavi
            items={[
              {
                text: i18n.t("pages.talent_pool.header_tabs.search"),
                to: `/talents`,
              },
              {
                text: i18n.t("pages.talent_pool.header_tabs.favorites"),
                to: `/favorites`,
              },
            ]}
          />
        </AppHeader>
      }
      previewMode={previewMode}
    >
      <section class="screenPadding__inner">
        <Hint page={previewMode ? "preview" : null} />
      </section>
      <FilterBar id={ID} />
      <ServerPaginated
        id={ID}
        fetchingMethod={talentsApi.fetch}
        storingMethod={setTalents}
        render={(talent) => (
          <Fragment key={talent.id}>
            <TalentPoolItem
              previewMode={previewMode}
              talent={talent}
              to={`/talents/${talent.id}`}
            />
          </Fragment>
        )}
        renderEmptyState={() => (
          <EmptyState
            icon="filtered_cases_empty"
            title={i18n.t("pages.talent_pool.empty.title")}
            description={i18n.t("pages.talent_pool.empty.description")}
          ></EmptyState>
        )}
      />
    </AppLayout>
  );
}
